import { gql } from '@apollo/client';

export const MY_EXPORT_JOBS = gql`
  query myExportJobs {
    myExportJobs {
      id
      reportType
      reportParams
      status
      access
      progress
      createdAt
      expiresAt
      completedAt
      failedAt
      canceledAt
      errorMessage
      requestedBy {
        id
        name
        email
      }
    }
  }
`;
